
import { Component, HostBinding, OnInit } from '@angular/core';

import { SettingsService } from './core/settings/settings.service';
import { AuthService } from './services/api/auth/auth.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DummyApiPaths } from './functions/dummy-api-paths';
import { CommonFunctionService } from './services/Common/common-function.service';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [SettingsService],
})
export class AppComponent implements OnInit {
  @HostBinding('class.layout-fixed') get isFixed() {
    return this.settings.getLayoutSetting('isFixed');
  }
  @HostBinding('class.aside-collapsed') get isCollapsed() {
    return this.settings.getLayoutSetting('isCollapsed');
  }
  @HostBinding('class.layout-boxed') get isBoxed() {
    return this.settings.getLayoutSetting('isBoxed');
  }
  @HostBinding('class.layout-fs') get useFullLayout() {
    return this.settings.getLayoutSetting('useFullLayout');
  }
  @HostBinding('class.hidden-footer') get hiddenFooter() {
    return this.settings.getLayoutSetting('hiddenFooter');
  }
  @HostBinding('class.layout-h') get horizontal() {
    return this.settings.getLayoutSetting('horizontal');
  }
  @HostBinding('class.aside-float') get isFloat() {
    return this.settings.getLayoutSetting('isFloat');
  }
  @HostBinding('class.offsidebar-open') get offsidebarOpen() {
    return this.settings.getLayoutSetting('offsidebarOpen');
  }
  @HostBinding('class.aside-toggled') get asideToggled() {
    return this.settings.getLayoutSetting('asideToggled');
  }
  @HostBinding('class.aside-collapsed-text') get isCollapsedText() {
    return this.settings.getLayoutSetting('isCollapsedText');
  }

  title = 'Merchant Dashboard';
  isLoading: boolean = false;

  constructor(
    public settings: SettingsService, private router: Router,
    private commonfunction: CommonFunctionService, private route: ActivatedRoute
  ) {

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      console.log(event.url);
      if (event.url == '/login') {
        this.login = true;
      }
    });
  }
  login = false;
  ngOnInit() { 
    const fullUrl = window.location.href;
    const clientId = this.getQueryParamFromUrl(fullUrl, 'client_id');
    if(clientId) localStorage.setItem('esign_client_id',clientId);
     
  }
  private getQueryParamFromUrl(url: string, param: string): string | null {
    const urlParts = url.split('?');
    if (urlParts.length > 1) {
      const queryParamsString = urlParts[1].split('#')[0];
      const queryParams = new URLSearchParams(queryParamsString);
      return queryParams.get(param);
    }
    return null;
  }

  getIP() {
    this.commonfunction.getIPAddress().subscribe((res: any) => {
      localStorage.setItem('ipaddress', res.ip);
    });
  }
}
